import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

// project-imports
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import Loadable from 'components/Loadable';

// render - public landing
const Landing = Loadable(lazy(() => import('pages/landing/Landing')));

// render - public legal pages
const DeveloperAgreement = Loadable(lazy(() => import('pages/legal/DeveloperAgreement')));

// render - public developer documentation (V15)
const DocsHome = Loadable(lazy(() => import('pages/docs/DocsHome')));
const DocsArticle = Loadable(lazy(() => import('pages/docs/DocsPage').then((module) => ({ default: module.DocsArticlePage }))));
const DocsSection = Loadable(lazy(() => import('pages/docs/DocsPage').then((module) => ({ default: module.DocsSectionPage }))));
const DocsUnknown = Loadable(lazy(() => import('pages/docs/DocsPage').then((module) => ({ default: module.DocsUnknownPage }))));

// ==============================|| ROUTES RENDER ||============================== //
//
// The exact "/" route (and the public legal and documentation pages) live here, as its own top-level leaf, outside every guard. It is the public
// landing page: a guest sees it, a signed-in admin sees the same page with "Open console". Nested inside
// AuthGuard's protected tree it would race that guard's own redirect to /login.

export default function ThemeRoutes() {
  return useRoutes([
    { path: '/', element: <Landing /> },
    { path: '/legal/developer-agreement', element: <DeveloperAgreement /> },

    // Public documentation. The developer page that used to live at /docs/publishing is now /publishing; the static path
    // outranks `/docs/:section`, so old links and bookmarks land there instead of in the docs 404.
    { path: '/docs', element: <DocsHome /> },
    { path: '/docs/publishing', element: <Navigate to="/publishing" replace /> },
    { path: '/docs/:section', element: <DocsSection /> },
    { path: '/docs/:section/:page', element: <DocsArticle /> },
    { path: '/docs/*', element: <DocsUnknown /> },
    LoginRoutes,
    MainRoutes
  ]);
}
